import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../modules/auth/context/AuthContext';

/**
 * Shown to whoever clicked an AI action when the company wallet is under the
 * floor. Admin, recruiter and manager all get the same message.
 */
export default function LowBalanceModal() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    const onLow = (event) => setDetail(event.detail || {});
    window.addEventListener('recruitai:low-balance', onLow);
    return () => window.removeEventListener('recruitai:low-balance', onLow);
  }, []);

  if (!detail) return null;

  const isAdmin = user?.role === 'admin';
  const balance = detail.balance_display;
  const minimum = detail.minimum_display;

  return (
    <div className="modal-backdrop" onClick={() => setDetail(null)}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 420 }}>
        <h3>Low wallet balance</h3>
        <p style={{ fontSize: 14, lineHeight: 1.6, color: 'var(--text-muted)', marginTop: 8 }}>
          {detail.message || 'Your company wallet is too low for AI. Add money, then try again.'}
        </p>
        {(balance || minimum) && (
          <p style={{ fontSize: 13, marginTop: 8 }}>
            {balance ? <>Balance {balance}. </> : null}
            {minimum ? <>AI needs at least {minimum}.</> : null}
          </p>
        )}
        <p style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 8 }}>
          {isAdmin
            ? 'Add money from Manage Wallet, then try this again.'
            : 'Ask a company admin to add money, then try this again.'}
        </p>
        <div className="modal-actions">
          <button type="button" className="btn" onClick={() => setDetail(null)}>Close</button>
          {isAdmin && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => { setDetail(null); navigate('/manage-wallet'); }}
            >
              Open wallet
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
